var render = function render(){var _vm=this,_c=_vm._self._c;return _c('datalist',_vm._b({},'datalist',_vm.$attrs,false),_vm._l((_vm.list),function(item){return _c('option',{key:_vm.makeKey('data_list_option', item),domProps:{"value":item}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }